import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../Actions';
// import { get } from 'Language';

class ContactUs extends Component {

    state = {
        email: '',
        fullname: '',
        message: '',
        phone: ''
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.reset) {
            const { onContactUs } = this.props;
            onContactUs(false);
            this.setState({
                email: '',
                fullname: '',
                message: '',
                phone: ''
            })
        }
    }

    handleOnChange = (e) => {
        const { name, value } = e.target;
        const nextState = {};
        nextState[name] = value;
        this.setState(nextState);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { contactUs } = this.props;
        contactUs(this.state);
    }

    render() {
        // const { isWaiting } = this.props;
        return (
            <form onSubmit={ this.handleSubmit }>
                <div className="response"></div>
                    <div className="form-group">
                        <input 
                            onChange={this.handleOnChange}
                            value={this.state.fullname}
                            type="text" 
                            name="fullname" 
                            className="form-control form-custom" 
                            placeholder="Full Name"/>
                    </div>
                    <div className="form-group">
                        <input 
                            onChange={this.handleOnChange}
                            value={this.state.email}
                            type="email" 
                            name="email" 
                            className="form-control form-custom" 
                            placeholder="E-mail"/>
                    </div>
                    <div className="form-group">
                        <input 
                            onChange={this.handleOnChange}
                            value={this.state.phone}
                            type="text" 
                            name="phone" 
                            className="form-control form-custom" 
                            placeholder="Phone"/>
                    </div>

                    <div className="form-group">
                        <textarea 
                            onChange={this.handleOnChange}
                            value={this.state.message}
                            name="message" 
                            className="form-control form-custom" 
                            placeholder="Message"/>
                    </div>

                    <div className="btn-custom">
                        <button disabled={this.props.isWaiting} type="submit" className="btn btn-primary">
                            { this.props.isWaiting
                                ? 'Sending...'
                                : 'Send'
                            }
                        </button>
                    </div>
            </form>
        );
    }
}

export default connect(
    state => {
 
        const { reset } = state.contact;
        const { isWaiting } = state.onWaiting;

        return {
            reset,
            isWaiting
        }
    },
    actions
)(ContactUs);



// WEBPACK FOOTER //
// ./src/partials/ContactUs.js